export default __webpack_public_path__ + "static/media/vkpic11.d6dee0e7.png";